import { render, staticRenderFns } from "./ServicesReservationsCardActions.vue?vue&type=template&id=65bb8faa&"
import script from "./ServicesReservationsCardActions.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationsCardActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports